import {retainWan} from "@/plugins/helper";

export const TYPE_MAP = {
  1: {
    label: '商品数',
    formatFn: value => retainWan(value,false,2,'--')
  },
  2: {
    label: '销量',
    formatFn: value => retainWan(value,false,2,'--')
  },
  3: {
    label: '销售额',
    formatFn: value =>` ¥${retainWan(value,false,2,'--')}`
  },
}

export const makeButtonList = (list = []) => {
  return list?.map(value => ({
    label: TYPE_MAP[value].label,
    value
  }))
}
